import React from "react";
import { motion } from "framer-motion";
import { Quote } from "lucide-react";
import { useLang } from "@/i18n/LanguageContext";
import { Reveal, SectionLabel } from "@/components/Reveal";

const About = () => {
  const { t } = useLang();

  return (
    <section
      id="azienda"
      data-testid="about-section"
      className="relative bg-forest-deep text-cream py-24 sm:py-32 lg:py-40 overflow-hidden"
    >
      <div className="max-w-[1400px] mx-auto px-6 sm:px-10 lg:px-14">
        <div className="grid lg:grid-cols-12 gap-12 lg:gap-16">
          {/* Left: story */}
          <div className="lg:col-span-7">
            <SectionLabel dark>{t("about.label")}</SectionLabel>
            <Reveal delay={0.1}>
              <h2 className="font-display font-light tracking-tight leading-[1.02] text-4xl sm:text-5xl lg:text-6xl mt-6 mb-10">
                {t("about.title")}
              </h2>
            </Reveal>
            <div className="space-y-6 max-w-2xl text-cream/75 text-base sm:text-lg font-light leading-relaxed">
              <Reveal delay={0.15}><p>{t("about.p1")}</p></Reveal>
              <Reveal delay={0.2}><p>{t("about.p2")}</p></Reveal>
              <Reveal delay={0.24}><p>{t("about.p3")}</p></Reveal>
            </div>

            <Reveal delay={0.25}>
              <div className="mt-12 border-l-2 border-gold pl-6">
                <span className="text-xs font-bold uppercase tracking-[0.24em] text-gold">
                  {t("about.missionLabel")}
                </span>
                <p className="mt-3 text-cream/80 font-light leading-relaxed max-w-xl">
                  {t("about.mission")}
                </p>
              </div>
            </Reveal>
          </div>

          {/* Right: quote (image removed by client request) */}
          <div className="lg:col-span-5 flex flex-col justify-center">
            <motion.blockquote
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.9, ease: [0.16, 1, 0.3, 1] }}
              className="relative bg-forest-surface rounded-tl-[2rem] rounded-br-[2rem] p-8 sm:p-10"
              data-testid="mission-quote"
            >
              <Quote className="text-gold mb-4" size={32} />
              <p className="font-display text-2xl sm:text-3xl font-light italic leading-snug text-cream">
                {t("about.quote")}
              </p>
            </motion.blockquote>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
